<template>
  <form :class="{ hasError: errors.any() }" @submit.prevent action="post">
    <form-row
      v-for="(field, index) in schema"
      :key="index"
      v-bind="field"
      :class="{ hasError: errors.has(field.name) }"
    >
      <component
        :is="field.fieldType"
        :value="field.fieldType === 'Grid' ? formData : formData[field.name]"
        v-bind="field"
        :form-valid="isFormValid"
        @input="updateForm(field, field.name, $event)"
        @click="clickFormGenerator"
      />
    </form-row>
  </form>
</template>

<script>
import FormRow from "@/components/form/FormRow";
import FormActions from "@/components/form/FormActions";
import FormDivider from "@/components/form/FormDivider";
import Button from "@/components/button/Button";
import AuthButton from "@/components/auth/GovId";
import AuthCard from "@/components/auth/AuthCard";

import FieldText from "@/components/input/InputText";
import FieldTextConfirmation from "@/components/input/InputTextConfirmation";
import FieldTextarea from "@/components/input/InputTextarea";

import FieldResponse from "@/components/input/InputRepeater";
import Tag from "@/components/tag/Tag";
import Alert from "@/components/alert/Alert";

import Number from "@/components/input/InputNumber";
import Date from "@/components/input/InputDate";
import DateMedicare from "@/components/input/InputDateMedicare";
import Radio from "@/components/input/InputRadio";
import Check from "@/components/input/InputCheckbox";
import Dropdown from "@/components/input/InputDropdown";
import MultiSelect from "@/components/input/InputMultiSelect";

import School from "@/components/school/School";

import PageHeading from "@/components/typography/PageHeading";
import FieldsetHeading from "@/components/typography/FieldsetHeading";
import FieldHeading from "@/components/typography/FieldHeading";
import FieldDateHeading from "@/components/typography/FieldDateHeading";

import Paragraph from "@/components/typography/Paragraph";
import List from "@/components/typography/List";
import Upload from "@/components/upload/Upload";

import Grid from "@/components/grid/Grid";

export default {
  name: "FormGenerator",
  inject: {
    $validator: "$validator"
  },
  props: {
    schema: {
      type: Array
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Grid,
    FormActions,
    FormDivider,
    Button,
    AuthButton,
    AuthCard,
    FormRow,
    PageHeading,
    FieldsetHeading,
    FieldHeading,
    FieldDateHeading,
    Paragraph,
    List,
    FieldText,
    FieldTextConfirmation,
    FieldTextarea,
    FieldResponse,
    Tag,
    Alert,
    Number,
    Date,
    DateMedicare,
    Radio,
    Check,
    School,
    Upload,
    Dropdown,
    MultiSelect
  },
  data() {
    return {
      formData: this.value || {}
    };
  },
  methods: {
    clickFormGenerator(payload) {
      this.$emit(payload);
    },
    updateForm(field, fieldName, value) {
      this.$set(this.formData, fieldName, value);
      this.$emit("form", {
        fieldName: fieldName,
        value: value
      });
    }
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(
        key => this.fields[key].valid === false
      );
    }
  }
};
</script>
